<nz-affix [nzOffsetTop]="0">
  <hx-breadcrumbs></hx-breadcrumbs>
  <nz-page-header nzBackIcon [nzGhost]="false">
    <nz-page-header-title>{{(isEdit ? 'action.edit' : 'action.create') | transloco}}</nz-page-header-title>
  </nz-page-header>
</nz-affix>

<nz-skeleton [nzActive]="true" [nzLoading]="isLoading.dictionary" *transloco="let tr; prefix: 'dictionaries'; scope: 'dictionaries'">
  <form class="hx-form" nz-form [nzLayout]="'vertical'" [formGroup]="form" (ngSubmit)="submitForm()">
    <div nz-row [nzGutter]="8">
      <div nz-col>
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('form.key')}}</nz-form-label>
          <nz-form-control>
            <input formControlName="key" nz-input>
          </nz-form-control>
        </nz-form-item>
      </div>

      <div nz-col>
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('form.enabled')}}</nz-form-label>
          <nz-form-control>
            <nz-switch formControlName="enabled"></nz-switch>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <div nz-row [nzGutter]="8">
      <div nz-col>
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('form.title')}}</nz-form-label>
          <nz-form-control>
            <hx-label-edit formControlName="title"></hx-label-edit>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <div nz-row [nzGutter]="8">
      <div nz-col class="hx-col-3">
        <nz-form-item>
          <nz-form-label>{{tr('form.description')}}</nz-form-label>
          <nz-form-control>
            <textarea formControlName="description" nz-input></textarea>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <nz-alert *ngIf="form.invalid" nzType="error" [nzMessage]="'error.fillRequiredFields' | transloco" nzShowIcon></nz-alert>

    <div nz-row [nzGutter]="8" class="cp_actions">
      <div nz-col>
        <nz-form-item>
          <nz-form-control>
            <button [nzLoading]="isSaving" [disabled]="form.pristine || form.pending" type="submit" nz-button nzType="primary">
              <i nz-icon nzType="save" nzTheme="outline"></i> {{'button.save' | transloco}}
            </button>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col>
        <nz-tag nzColor="success" *ngIf="form.pristine && dictionary?.id">
          <i nz-icon nzType="check-circle"></i>
          <span>{{'form.saved' | transloco}}</span>
        </nz-tag>
      </div>
    </div>
  </form>
</nz-skeleton>
